/**
 * 공용 모달 엔진 (사이트 공통) — 관리자/모바일/악덕 어디서나 동일 엔진, 스타일만 사이트별.
 *
 *   const m = $j.Ui.Modal.open({
 *       title: '전화 연결',
 *       html: '<p>...</p>',
 *       mode: 'center',        // 'center'(기본) | 'sheet'(하단) | 'full'(전체화면) | 'right'(우측도킹)
 *       dismissible: true,     // 백드롭/ESC 로 닫기 허용
 *       width: '420px',        // center 모드 최대폭
 *       variant: 'devil',      // 테마 훅(클래스 ui-modal--v-devil) — scss 에서 사이트별 오버라이드
 *       onClose: () => {},
 *   });
 *   m.close(); m.setTitle('...'); m.setBody('<p>...</p>'); m.el; // jQuery 패널
 *
 * 스택: 여러 모달이 겹쳐도 $j.Ui.Layer 로 레벨별 z-index 부여(최신이 위).
 *   modal z-index 슬롯(1055)이 BS(1035)보다 위라, BS 안에서 연 모달도 자연히 위에 뜬다.
 *
 * 테마: 구조 CSS 는 JS 가 1회 주입(중립, CSS 변수 기반)하고, 색/라운드/폰트는
 *   --ui-modal-* 변수로 노출한다. 사이트 scss 가 :root 또는 스코프에서 변수만 덮으면 된다.
 */
let _seq = 0;

export default class Modal {
    constructor() {
        this._styleInjected = false;
    }

    /** @return {{id,el,overlay,close,setTitle,setBody}} 핸들 */
    open = (opts = {}) => {
        this._injectStyle();
        const id = opts.id || ('ui-modal-' + (++_seq));
        const mode = opts.mode || 'center';
        const dismissible = opts.dismissible !== false;

        // 기존 동일 id 는 교체(재사용)
        $('#' + id + '-ov').remove();
        $('#' + id).remove();

        const titleHtml = opts.title != null ? String(opts.title) : '';
        const $overlay = $(`<div class="ui-modal-overlay" id="${id}-ov"></div>`);
        const $modal = $(`
<div class="ui-modal ui-modal--${mode} ${opts.variant ? 'ui-modal--v-' + opts.variant : ''} ${opts.panelClass || ''}" id="${id}" role="dialog" aria-modal="true">
  <div class="ui-modal__header">
    <h3 class="ui-modal__title">${titleHtml}</h3>
    <button type="button" class="ui-modal__close" aria-label="닫기">&times;</button>
  </div>
  <div class="ui-modal__body">${opts.html != null ? opts.html : ''}</div>
</div>`);

        if (opts.width && (mode === 'center' || mode === 'right')) $modal.css('min-width', opts.width); // JBModal 호환(min-width 기준)

        // 폭 상한. 창은 width:auto 라 **내용이 넓으면 화면 끝까지 늘어난다** — 긴 안내문 한 줄이
        // 창을 가로로 벌려 읽기 나쁘게 만든다. 글줄이 있는 창은 이걸로 줄길이를 잡는다
        if (opts.maxWidth) {
            $modal.css('max-width', typeof opts.maxWidth === 'number' ? opts.maxWidth + 'px' : opts.maxWidth);
        }
        if (!titleHtml) $modal.find('.ui-modal__header').addClass('is-empty');

        $('body').append($overlay).append($modal);

        const handle = {
            id,
            el: $modal,
            overlay: $overlay,
            close: () => this._close(id, opts.onClose),
            setTitle: (t) => $modal.find('.ui-modal__title').html(t == null ? '' : t),
            setBody: (h) => $modal.find('.ui-modal__body').html(h == null ? '' : h),
        };

        // 닫기 — X 버튼 / (dismissible 면) 백드롭
        $modal.find('.ui-modal__close').on('click', handle.close);
        if (dismissible) $overlay.on('click', handle.close);

        // 스택 z-index
        const { backdrop, panel } = $j.Ui.Layer.push(id) != null ? $j.Ui.Layer.z(id) : { backdrop: 1050, panel: 1055 };
        // ⚠ $j.Ui.ZoomPhoto(전체화면 사진뷰어, .mc-fullscreen-overlay, z-index 99999985) 는
        //   이 Layer 스택 밖의 독자 오버레이다. 그 위에서 모달을 열면(불러톡 스티커인증샷
        //   지급 확인창 등, F/Chat/Photo.js) 평소 스택 레벨(1050대)로는 항상 사진 밑에
        //   깔려 안 보이고 클릭도 안 먹는다 — 열려 있을 때만 그 위로 밀어 올린다
        //   (토스트 z-index 99999992 보다는 아래 — admin/components/_toast.scss).
        const aboveZoom = document.querySelector('.mc-fullscreen-overlay') != null;
        $overlay.css('z-index', aboveZoom ? 99999990 : backdrop);
        $modal.css('z-index', aboveZoom ? 99999991 : panel);

        // 하단시트/전체화면은 배경 스크롤락(iOS 안전 패턴). BS 와 'bs-body-locked' 클래스로 협조.
        if (mode === 'sheet' || mode === 'full') this._lockBody(handle);

        // 등장 애니메이션 (다음 프레임에 is-open)
        // rAF 는 탭이 렌더링하지 않는 순간엔 불리지 않는다. 그때 is-open 이 안 붙으면
        // 모달이 opacity:0 으로 남아 '열렸는데 안 보이는' 상태가 된다 — 타이머로 한 번 더 건다
        // (addClass 는 두 번 불려도 무해하고, 30ms 면 전이는 그대로 보인다).
        const reveal = () => { $overlay.addClass('is-open'); $modal.addClass('is-open'); };
        requestAnimationFrame(reveal);
        setTimeout(reveal, 30);

        // ESC 닫기(최상단만)
        if (dismissible) {
            const onKey = (e) => {
                if (e.key === 'Escape' && $j.Ui.Layer.top() === id) handle.close();
            };
            $(document).on('keydown.' + id, onKey);
            handle._onKey = onKey;
        }
        handle._onClose = opts.onClose;
        this._lastHandles = this._lastHandles || {};
        this._lastHandles[id] = handle;

        if (opts.onOpen) opts.onOpen(handle);
        return handle;
    }

    /** id 로 닫기(외부에서도 호출 가능). id 없으면 최상단. */
    close = (id) => {
        if (!id) { const t = $j.Ui.Layer.top(); if (t) id = t; else return; }
        const h = this._lastHandles && this._lastHandles[id];
        this._close(id, h && h._onClose);
    }

    _close = (id, onClose) => {
        const $modal = $('#' + id);
        const $ov = $('#' + id + '-ov');
        if (!$modal.length) return;
        const h = this._lastHandles && this._lastHandles[id];
        this._unlockBody(h);
        $(document).off('keydown.' + id);
        // is-closing — 닫히는 중(200ms 뒤 제거)과 열리는 중(is-open 직전)을 밖에서 가를 수 있게 (Toast 가 본다)
        $modal.removeClass('is-open').addClass('is-closing');
        $ov.removeClass('is-open');
        $j.Ui.Layer.remove(id);
        setTimeout(() => { $modal.remove(); $ov.remove(); }, 200);
        if (this._lastHandles) delete this._lastHandles[id];
        if (onClose) onClose();
    }

    // ── 배경 스크롤락 (BS 와 'bs-body-locked' 클래스 공유 — 먼저 잠근 오버레이만 해제) ──
    _lockBody = (handle) => {
        if (typeof document === 'undefined') return;
        if (document.body.classList.contains('bs-body-locked')) return; // 이미 잠김(BS/다른 오버레이)
        this._savedScrollY = window.scrollY || window.pageYOffset || 0;
        const s = document.body.style;
        s.position = 'fixed'; s.top = `-${this._savedScrollY}px`; s.left = '0'; s.right = '0'; s.width = '100%';
        document.body.classList.add('bs-body-locked');
        if (handle) handle._lockedBody = true;
    }
    _unlockBody = (handle) => {
        if (!handle || !handle._lockedBody) return;
        const s = document.body.style;
        s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.width = '';
        document.body.classList.remove('bs-body-locked');
        window.scrollTo(0, this._savedScrollY || 0);
        handle._lockedBody = false;
    }

    _injectStyle = () => {
        if (this._styleInjected) return;
        this._styleInjected = true;
        // 구조 CSS(중립) + 테마 훅(--ui-modal-*). 사이트 scss 가 변수만 덮으면 룩이 바뀐다.
        const css = `
:root{
  --ui-modal-bg:#fff; --ui-modal-radius:16px; --ui-modal-backdrop:rgba(0,0,0,.5);
  --ui-modal-shadow:0 12px 40px rgba(0,0,0,.28);
  --ui-modal-header-border:#eee; --ui-modal-title-color:#212529; --ui-modal-title-size:17px;
  --ui-modal-pad:18px; --ui-modal-close-color:#868e96;
}
.ui-modal-overlay{position:fixed;inset:0;background:var(--ui-modal-backdrop);opacity:0;transition:opacity .18s ease}
.ui-modal-overlay.is-open{opacity:1}
/* 92dvh — 폰 브라우저의 주소표시줄이 보이는 동안 vh 는 '주소줄이 숨었을 때' 높이라 창이 화면보다 커진다.
   하단 시트는 bottom 기준이라 그만큼 머리(제목)가 주소줄 뒤로 잘렸다(2026-10-07 상필 님 QA).
   dvh 를 모르는 브라우저는 앞 줄(vh)로 남는다. */
.ui-modal{position:fixed;background:var(--ui-modal-bg);box-shadow:var(--ui-modal-shadow);display:flex;flex-direction:column;max-height:calc(92vh / var(--adm-zoom, 1) / var(--fs-zoom, 1));max-height:calc(92dvh / var(--adm-zoom, 1) / var(--fs-zoom, 1));opacity:0;overflow:hidden}
.ui-modal.is-open{opacity:1}
.ui-modal__header{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:14px var(--ui-modal-pad);border-bottom:1px solid var(--ui-modal-header-border)}
.ui-modal__header.is-empty{border-bottom:0;padding-bottom:0}
.ui-modal__title{margin:0;font-size:var(--ui-modal-title-size);font-weight:800;color:var(--ui-modal-title-color)}
.ui-modal__close{border:none;background:#f1f3f5;color:var(--ui-modal-close-color);width:30px;height:30px;border-radius:8px;font-size:20px;line-height:1;cursor:pointer;flex:none}
.ui-modal__close:hover{background:#e9ecef;color:#212529}
.ui-modal__body{padding:var(--ui-modal-pad);overflow-y:auto;flex:1 1 auto}
/* center */
.ui-modal--center{top:50%;left:50%;transform:translate(-50%,-50%) scale(.98);width:auto;min-width:min(calc(92vw / var(--adm-zoom, 1) / var(--fs-zoom, 1)),340px);max-width:calc(96vw / var(--adm-zoom, 1) / var(--fs-zoom, 1));border-radius:var(--ui-modal-radius);transition:opacity .18s ease,transform .18s ease}
.ui-modal--center.is-open{transform:translate(-50%,-50%) scale(1)}
/* variant: admin — 기존 JBModal 룩 보존(회색 헤더/작은 라운드/평문 X) */
.ui-modal--v-admin{--ui-modal-radius:6px;--ui-modal-header-border:#ddd;--ui-modal-title-size:15px;--ui-modal-pad:15px}
.ui-modal--v-admin .ui-modal__header{background:#f8f8f8}
.ui-modal--v-admin .ui-modal__title{font-weight:bold}
.ui-modal--v-admin .ui-modal__close{background:none;color:#666;font-size:22px;width:auto;height:auto;border-radius:0}
.ui-modal--v-admin .ui-modal__close:hover{background:none;color:#000}
.ui-modal--v-admin .ui-modal__body{padding:var(--ui-modal-pad)}
.ui-modal--v-admin.ui-modal--center{min-width:min(calc(92vw / var(--adm-zoom, 1) / var(--fs-zoom, 1)),480px)}
/* sheet(하단) */
.ui-modal--sheet{left:0;right:0;bottom:0;width:100%;padding-bottom:var(--ui-modal-bottom-inset,0px);border-radius:var(--ui-modal-radius) var(--ui-modal-radius) 0 0;transform:translateY(100%);transition:opacity .22s ease,transform .22s cubic-bezier(.25,1,.5,1)}
.ui-modal--sheet.is-open{transform:translateY(0)}
/* full / right */
.ui-modal--full{inset:0;width:100%;max-height:calc(100vh / var(--adm-zoom, 1) / var(--fs-zoom, 1));border-radius:0;transform:none;transition:opacity .18s ease}
.ui-modal--right{top:0;right:0;bottom:0;height:calc(100vh / var(--adm-zoom, 1) / var(--fs-zoom, 1));max-height:calc(100vh / var(--adm-zoom, 1) / var(--fs-zoom, 1));border-radius:0;transform:translateX(100%);transition:transform .2s ease}
.ui-modal--right.is-open{transform:translateX(0)}
@media(max-width:520px){ .ui-modal--center{border-radius:var(--ui-modal-radius)} }
`;
        $('<style id="ui-modal-base">').text(css).appendTo('head');
    }
}
